<template>
  <div class="PicReportModal">

    <div>
      <RelevancePic :detail="detail"/>
    </div>


    <div class="pic-report-box">
      <div class="pic-report pic-report-sidechat" @click="navigateTo">
        <i class="iconfont icon-a-sidechat"></i>反馈
      </div>
      <div class="line"></div>

      <div class="pic-report " @click="picReport">
        <i class="iconfont icon-report"></i>举报
      </div>
    </div>

    <CgModalMiddle v-show="isShow"  @close="isShow = false">
      <div slot="modal_content" class="modal-content">
        <div class="report-title">
          <i class="icon_warn"></i>
          图片举报
        </div>
        <ul class="report-types">
          <li
            v-for="vo in reportTypes"
            :key="vo.label"
            class="report-type"
            @click="toggleSelected(vo)"
          >
            <i
              class="icon-circle"
              :class="{ 'on': vo.isSelected }"
            ></i>
            {{ vo.label }}
          </li>
        </ul>
        <div class="report-types-err-tips" v-show="reportTypeErr">
          {{ reportTypeErrTxt }}
        </div>
        <div class="report-content">
          <div class="title">举报取证 <i>*</i></div>
          <textarea v-model="reportContent" class="" name="" id="" cols="30" rows="10"
                    placeholder="请详细描述，并提供图片链接（必填）"
                    @input="input"
          ></textarea>
          <div class="err-tips" v-if="reportContentErr">

            {{ reportContentErrTxt }}
          </div>

          <div class="text-num">
            <span class="input">{{ reportContent.length > 200 ? 200 : reportContent.length }}</span>/<span
            class="total">200</span>
          </div>
        </div>
        <div class="report-content report-content2">
          <div class="title">如需反馈请留下联系方式 </div>
          <input type="text" v-model="remark" placeholder="请输入QQ / 微信 / 邮箱，任一联系方式即可">

        </div>


        <div class="report-submit" @click="submit">提交</div>

      </div>
    </CgModalMiddle>
  </div>
</template>

<script>
import {fnLogin, fnRouter} from "@/fn";
import {picReport} from "@/api/material";
import _ from 'lodash'
import {ENV_BASE_URL} from "@/constant/PATH";
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import RelevancePic from '@/components/tupian/detail/relevance-pic'


const reportTypes = [
  {
    label: '图片违反法律法规',
    isSelected: false
  },
  {
    label: '图片盗版或侵权',
    isSelected: false
  },
  {
    label: '源文件为合层文件',
    isSelected: false
  },
  {
    label: '格式与描述不符',
    isSelected: false
  },
  {
    label: '压缩包解压出错',
    isSelected: false
  },
  {
    label: '文件损坏打不开',
    isSelected: false
  },
]
export default {
  name: "PicReportModal",
  components:{
    RelevancePic
  },
  props: {
    /* 详情 */
    detail: {
      type: Object,
      default: () => {

      }
    },
  },
  data() {
    return {
      isShow: false,
      reportTypes,
      reportContent: '',
      reportContentErrTxt: '请填写举报取证',
      reportContentErr: false,
      reportTypeErrTxt: '请勾选图片举报类型',
      reportTypeErr: false,
      ENV_BASE_URL,
      remark:''
    }
  },
  methods: {
    picReport() {
      if (fnLogin.checkLogin()) {
        this.isShow = true

      } else {
        fnLogin.loginIntercept(false)
      }

    },
    toggleSelected(vo) {
      if (vo.isSelected === false) {
        this.reportTypes.map(vo => vo.isSelected = false);
      }
      vo.isSelected = !vo.isSelected;

      /* 检查是否勾选 */
      // this.checkReportType();
    },
    input() {
      // console.log(1111)
      if (this.reportContent.length == 0) {
        this.reportContentErr = true
        this.reportContentErrTxt = '请填写举报取证'
        return
      }

      if (this.reportContent.length > 200) {
        this.reportContentErr = true
        this.reportContentErrTxt = '举报取证最多输入200字'
        this.reportContent = this.reportContent.slice(0, 200)
      } else {
        this.reportContentErr = false
        this.reportContentErrTxt = '举报取证最多输入200字'
      }
    },

    checkReportType() {
      let boolSelect = this.reportTypes.some(vo => {
        return vo.isSelected
      })
      if (!boolSelect) {
        this.reportContentErrTxt = '请填写举报取证';
        this.reportTypeErr = true;
        return false
      } else {
        this.reportContentErrTxt = '';
        this.reportTypeErr = false
        return true
      }

    },
    checkReportContent() {
      this.reportContent = this.reportContent.replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll(' ', '')
      this.input();
      return this.reportContent.length > 0;

    },

    submit: _.throttle(function () {

      let imgUrl = ENV_BASE_URL + this.$route.path
      this.checkReportType()
      this.checkReportContent()

      if (this.checkReportType() && this.checkReportContent()) {
        let findReportType = this.reportTypes.find(vo => vo.isSelected == true)
        let params = {
          question: findReportType.label,
          description: this.reportContent,
          url: imgUrl,
          remark: this.remark
        }
        picReport(params).then(res => {
          let {status, msg} = res.data
          if (status == 1) {
            this.$myNotify.success('提交成功，感谢您的反馈', () => {
              this.clearForm();
              this.isShow = false;
            }, 1500)

          } else if (status == 0) {
            this.$myNotify.error('提交失败')
          } else if (status == 2) {
            this.$myNotify.error(msg)
          }

        })
      }
    }, 2000),

    clearForm() {
      this.reportTypes.map(vo => vo.isSelected = false);
      this.reportContent = '';
    },

    navigateTo(url) {
      fnRouter.navigationTo(PAGE_PATH.FEEDBACK)
    }

  }
}
</script>

<style lang="scss" scoped>

.PicReportModal {
  width: 434px;
  position: relative;
  z-index: 8;
  display: flex;
  align-items: center;
  justify-content: space-between;

  /deep/.Modal{
    margin-top: 40px;
  }

  .modal-content {
    width: 638px;
    height: 573px;
    padding: 41px 48px 32px;
    box-sizing: border-box;
    border-radius: 14px;

    width: 622px;
    height: 571px;
    background: #FFFFFF;
    box-shadow: -4px 0px 12px 0px rgba(0,0,26,0.06);
    border-radius: 14px;

    .report-title {
      font-size: 20px;
      font-weight: bold;
      color: #2D2B33;
      line-height: 27px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .icon_warn {
        @include BgImage(26px, 26px, 'tupian/icon_warn@active.png');
        margin-right: 14px;
      }
    }

    .report-types {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 600px;
      margin-bottom: 14px;

      .report-type {
        width: 218px;
        //margin-right: 32px;
        font-size: 15px;
        color: #2D2B33;
        line-height: 20px;
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        cursor: pointer;

        .icon-circle {
          @include BgImage(16px, 16px, 'tupian/icon_circle.png');
          margin-right: 10px;
          cursor: pointer;

          &.on {
            @include BgImage(16px, 16px, 'tupian/icon_circle@active.png');
          }
        }
      }

    }

    .report-types-err-tips {
      font-size: 12px;
      color: #EE5253;
      line-height: 16px;
    }

    .report-content {
      //margin-top: 16px;
      margin-bottom: 28px;
      position: relative;

      &.report-content2{
        margin-bottom: 22px;
      }


      .title {
        font-size: 15px;
        color: #2D2B33;
        line-height: 20px;
        margin-bottom: 14px;

        i {
          font-size: 15px;
          color: #EE5253;
        }
      }

      textarea {
        width: 526px;
        height: 106px;
        background: #F5F6FA;
        border-radius: 14px;
        padding: 20px 20px 38px;
        box-sizing: border-box;
        color: #2D2B33;

        &::placeholder {
          font-size: 14px;
          line-height: 20px;
          color: rgba(45, 43, 51,0.6);
        }
      }

      input{
        width: 526px;
        height: 56px;
        background: #F5F6FA;
        border-radius: 14px;
        line-height: 56px;
        padding-left: 20px;
        box-sizing: border-box;

        &::placeholder {
          font-size: 14px;
          line-height: 20px;
          color: rgba(45, 43, 51,0.6);
        }
      }

      .err-tips {
        @include Position(1, 4, 0, -20px);
        font-size: 12px;
        color: #EE5253;
        line-height: 16px;
      }

      .text-num {
        @include Position(1, 3, 20px, 12px);
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 16px;

        span {
        }

        .input {

        }

        .total {

        }

      }

    }


    .report-submit {
      width: 200px;
      height: 52px;
      background: #6969FF;
      border-radius: 14px;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 52px;
      text-align: center;
      cursor: pointer;
      @include ElementHover('', #5E5EE8);
    }
  }
}


.pic-introduce-panel {
  position: relative;
}

.pic-report-box{
  //margin-left: 317px;
  display: flex;
  align-items: center;
  //width: 434px;
  //justify-content: flex-end;


  .line{
    width: 1px;
    height: 12px;
    background: #C4C6D5;
    color: #C4C6D5;
    margin: 0 12px;
  }
}

.pic-report {
  //@include Position(1, 3, 52px, -32px);
  font-size: 13px;
  color: rgba(89, 96, 136,0.6) !important;
  display: flex;
  //justify-content: flex-end;

  //margin-right: 52px;
  .iconfont{
    margin-right: 6px;
  }

  .icon_report {
    @include BgImage(14px, 14px, 'tupian/icon_warn.png?v=2');
    margin-right: 6px;
    margin-top: 2px;
  }

  &.pic-report-sidechat{
    color: rgba(89, 96, 136,0.6) !important;
    @include ElementHover(#596088, '')
  }

  @include ElementHover(#596088, '') {
    .icon_report {
      @include BgImage(14px, 14px, 'tupian/icon_warn@active.png');
    }
  }
}

</style>
